/** Formateo en español de Ecuador. Las fechas de boda son fechas sin hora
 *  (YYYY-MM-DD), así que todo se interpreta en UTC para que no se corran un día
 *  según la zona horaria del invitado. */

const LARGA = new Intl.DateTimeFormat('es-EC', { dateStyle: 'long', timeZone: 'UTC' })
const COMPLETA = new Intl.DateTimeFormat('es-EC', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
})
const CORTA = new Intl.DateTimeFormat('es-EC', { dateStyle: 'short', timeZone: 'UTC' })
const CON_HORA = new Intl.DateTimeFormat('es-EC', { dateStyle: 'medium', timeStyle: 'short' })

function aFecha(iso: string | null | undefined): Date | null {
  if (!iso) return null
  const fecha = new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso)
  return Number.isNaN(fecha.getTime()) ? null : fecha
}

/** "19 de diciembre de 2026" */
export function fechaLarga(iso: string | null | undefined): string {
  const fecha = aFecha(iso)
  return fecha ? LARGA.format(fecha) : ''
}

/** "sábado, 19 de diciembre de 2026" */
export function fechaCompleta(iso: string | null | undefined): string {
  const fecha = aFecha(iso)
  return fecha ? COMPLETA.format(fecha) : ''
}

export function fechaCorta(iso: string | null | undefined): string {
  const fecha = aFecha(iso)
  return fecha ? CORTA.format(fecha) : ''
}

/** Para timestamps con hora (registros de correo, subidas). */
export function fechaHora(iso: string | null | undefined): string {
  const fecha = aFecha(iso)
  return fecha ? CON_HORA.format(fecha) : ''
}

export interface Restante {
  dias: number
  horas: number
  minutos: number
  segundos: number
  /** true si la fecha ya pasó. */
  pasada: boolean
}

/** Cuenta regresiva hasta las 00:00 UTC del día de la boda. */
export function cuentaRegresiva(iso: string | null | undefined, ahora = Date.now()): Restante | null {
  const fecha = aFecha(iso)
  if (!fecha) return null

  const delta = fecha.getTime() - ahora
  const pasada = delta <= 0
  const abs = Math.abs(delta)

  return {
    dias: Math.floor(abs / 86_400_000),
    horas: Math.floor((abs % 86_400_000) / 3_600_000),
    minutos: Math.floor((abs % 3_600_000) / 60_000),
    segundos: Math.floor((abs % 60_000) / 1000),
    pasada,
  }
}

/** Días enteros que faltan. Negativo si ya pasó. null si no hay fecha. */
export function diasHasta(iso: string | null | undefined, ahora = Date.now()): number | null {
  const fecha = aFecha(iso)
  if (!fecha) return null
  const hoy = new Date(ahora)
  const hoyUtc = Date.UTC(hoy.getUTCFullYear(), hoy.getUTCMonth(), hoy.getUTCDate())
  return Math.round((fecha.getTime() - hoyUtc) / 86_400_000)
}

/** plural(1, 'invitado', 'invitados') -> "1 invitado" */
export function plural(n: number, singular: string, pluralForma: string): string {
  return `${n} ${n === 1 ? singular : pluralForma}`
}

/** 3500 -> "$35,00" */
export function dinero(centavos: number, moneda = 'USD'): string {
  return new Intl.NumberFormat('es-EC', { style: 'currency', currency: moneda }).format(
    centavos / 100,
  )
}

/** "12 345" con separador de miles legible. */
export function numero(n: number): string {
  return new Intl.NumberFormat('es-EC').format(n)
}

/** Los límites del plan Premium llegan como null desde la API. */
export function limite(valor: number | null): string {
  return valor === null ? 'sin límite' : numero(valor)
}

export function porcentaje(hechos: number, total: number): number {
  if (total <= 0) return 0
  return Math.round((hechos / total) * 100)
}
